// Get the toggle switch element
const darkModeToggle = document.getElementById('dark-mode-toggle');

// Check if dark mode is already enabled
const isDarkModeEnabled = () => {
  return document.body.classList.contains('dark-mode');
};

// Enable dark mode
const enableDarkMode = () => {
  document.body.classList.add('dark-mode');
  localStorage.setItem('darkModeEnabled', true);
  darkModeToggle.checked = true;
  document.documentElement.setAttribute('data-theme', 'dark');
  document.getElementById('mode-indicator').textContent = "Dark Mode Enabled";
};

// Disable dark mode
const disableDarkMode = () => {
  document.body.classList.remove('dark-mode');
  localStorage.setItem('darkModeEnabled', false);
  darkModeToggle.checked = false;
  document.documentElement.setAttribute('data-theme', 'light');
  document.getElementById('mode-indicator').textContent = "Light Mode Enabled";
};

// Toggle dark mode
const toggleDarkMode = () => {
  if (isDarkModeEnabled()) {
    disableDarkMode();
  } else {
    enableDarkMode();
  }
};

// Listen for clicks on the toggle switch
darkModeToggle.addEventListener('click', toggleDarkMode);

// Check if user's preference for dark mode is stored in local storage
if (localStorage.getItem('darkModeEnabled') === 'true' || localStorage.getItem('darkModeEnabled') === null) {
  enableDarkMode(); // Set the initial mode to dark mode
} else {
  disableDarkMode();
}

// Set the initial state of the toggle switch
darkModeToggle.checked = isDarkModeEnabled();
